module.exports = __webpack_public_path__ + "static/5-a36035be07679e88b60c63dc582eeb55.jpg";